import _ from 'underscore';
import popHeaderTemplate from './period-over-period-header.pug';

const biPattern = /^(Phone)?PerformanceMetrics\//;
const biSubColPattern = /^PopSubCol/;
export const biSubColPrefix = 'PopSubCol';

function groupHandler(e) {
  const name = this.$(e.target).closest('th, .th').attr('data-name');
  const popColumnsCur = this.get('popColumns');
  const popColumns = _.defaults({
    expandedCols: _.contains(popColumnsCur.expandedCols, name) ?
      _.without(popColumnsCur.expandedCols, name) :
      _.union(popColumnsCur.expandedCols, [name]),
  }, popColumnsCur);

  const sortableHeaderCur = this.get('sortableHeader') || {};
  let sortableHeader = null;

  if (sortableHeaderCur.name === name) {
    sortableHeader = _.defaults({ name: `${biSubColPrefix}${name}` }, sortableHeaderCur);
  } else if (sortableHeaderCur.name === `${biSubColPrefix}${name}`) {
    sortableHeader = _.defaults({ name }, sortableHeaderCur);
  }

  if (sortableHeader) {
    this.set({ sortableHeader });
  }

  e.stopPropagation();

  this.set({ popColumns });

  // This is a workaround for the column alignment issue on IE
  // After redrawing the table with new column set, IE and Edge doesn't relayout
  // the table correctly. We need to reattach the table to DOM to force relayout
  this.once('didUpdate', () => { // eslint-disable-line no-invalid-this
    const elTable = this.$('table').get(-1); // eslint-disable-line no-invalid-this

    if (elTable) {
      elTable.parentElement.appendChild(elTable);
    }
  });
}

function isPoPColumn(column) {
  return column &&
    !biSubColPattern.test(column.name) &&
    column.property &&
    biPattern.test(column.property.key);
}

export const popHeader = {
  name: 'popHeader',
  handler: function popHeader(state, { i18n }) {
    const patch = {};

    if (state.popStatus.isComparing) {
      patch.headRows = _.map(state.headRows, (row) => {
        let isPopHeaderRow = false;
        const patchRow = {};

        patchRow.cells = _.map(row.cells, (cell) => {
          const patchCell = {};
          const column = state.columnGroup.columnIndex[cell.name];

          if (isPoPColumn(column)) {
            const expanded = column.columns && column.columns.length > 0;

            patchCell.html = popHeaderTemplate({
              html: cell.html,
              icon: expanded ? 'minus' : 'plus',
              ariaLabel:
                expanded ? i18n.getString(_TL_('Click to minimize column {{columnName}}'), { columnName: column.title })
                  : i18n.getString(_TL_('Click to expand column {{columnName}}'), { columnName: column.title }),
            });

            if (expanded) {
              patchCell.classes = _.chain(cell.classes)
                .without('text-left', 'text-right')
                .union(['text-center', 'pop-column-header'])
                .value();
            } else {
              patchCell.classes = _.union(cell.classes, ['pop-column-header']);
            }

            isPopHeaderRow = true;
          } else if (isPoPColumn(_.result(column, 'parent'))) {
            patchCell.classes = _.union(cell.classes, ['pop-column-header']);
            isPopHeaderRow = true;
          }

          return _.defaults(patchCell, cell);
        });

        if (isPopHeaderRow) {
          patchRow.classes = _.union(row.classes, ['pop-enabled']);
        }

        return _.defaults(patchRow, row);
      });

      patch.events = _.defaults({
        'click span.pop-toggle-icon': groupHandler,
      }, state.events);
    }

    return _.defaults(patch, state);
  },
};
